import * as React from "react";
import styles from "./NavItem.module.scss";
import { NavLink } from "react-router-dom";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

export interface NavItemProps {
  onClick?: any;
  children?: JSX.Element | JSX.Element[];
  navIcon?: JSX.Element;
  navText: string;
  active?: boolean;
  title?: string;
  expanded: boolean;
  to?: string;
  externalLink?: boolean;
}

const NavItem = (props: NavItemProps) => {
  // Initialisation des states
  const [subMenuOpen, setSubMenuOpen] = React.useState<boolean>(false);
  const [subMenuAnchor, setSubMenuAnchor] = React.useState<{ top: number; left: number; }>(null);

  // Fonction appellée lors du survol d'un icone ou il y a un sous menu pour placer le sous menu par rapport à l'icone et par rapport au scroll dans le menu
  const openSubMenuHover = (ref: React.MutableRefObject<HTMLInputElement>) => (event: React.MouseEvent<HTMLDivElement>) => {
    // Pour le positionnement du sous menu au hover en hauteur on prend le offsettop de l'icone et on soustrait le scrolltop de son parent qui lui est avec le scroll.
    // Si on ne fait pas ça le sous menu ne suis pas le scroll et reste à l'emplacement d'origine
    // Pour le positionnement à gauche on prend offsetLeft de l'icone + sa largeur (offsetWidth)
    const menuAnchor = {
      top: event.currentTarget.offsetTop - event.currentTarget.parentElement.scrollTop,
      left: event.currentTarget.offsetLeft + event.currentTarget.offsetWidth
    }

    // On récupére la ref de l'élément subMenuHover pour voir si il faut afficher le sous menu vers le haut ou vers le bas pour pouvoir le voir dans la fenetre et qui ne sorte pas de l'écran
    const subMenuRef = ref.current;

    // Si la position top du subMenu + la hauteur du sous menu est plus grande que la hauteur de la fenetre alors on enlève à la position top la hauteur du sous menu et la hauteur de l'icone.
    if (menuAnchor.top + subMenuRef.clientHeight > window.innerHeight) {
      menuAnchor.top = menuAnchor.top - (subMenuRef.clientHeight - event.currentTarget.clientHeight);
    }

    setSubMenuAnchor(menuAnchor);
  }

  // On check si c'est un lien externe ou pas. Si lien externe on mets un a si c'est un lien interne on utilise NavLink de react router. Si pas de lien on fait juste une div
  let LinkComponent: React.ElementType = props.to != undefined && props.to != null ? props.externalLink ? "a" : NavLink : "div";

  // Préparation des données à passer au lien
  const linkData: {
    title: string;
    className: string;
    style: React.CSSProperties;
    href?: string;
    to?: string;
    onClick?: any;
  } = {
    title: props.title != undefined && props.title != null ? props.title : props.navText,
    className: styles.navItemContainer,
    style: props.active ? { backgroundColor: "var(--menu-activeColor)" } : {}
  };

  if (props.externalLink) {
    linkData.href = props.to;
  }
  else {
    linkData.to = props.to;
  }

  if (props.onClick != undefined && props.onClick != null) {
    linkData.onClick = () => props.onClick();
  }

  // En fonction de si il a des enfants et donc un sous menu on fait un render différent
  if (props.children != undefined) {
    const subLinkMenuHover = React.useRef<HTMLInputElement>(null);
    linkData.onClick = () => setSubMenuOpen(!subMenuOpen);
    let classNameSubMenu = styles.navItemContainerWithSubMenu;
    if (subMenuOpen == true) {
      classNameSubMenu += " " + styles.subMenuOpen;
    }
    if (props.expanded == false) {
      classNameSubMenu += " " + styles.navIsClose;
    }
    return (
      <div className={classNameSubMenu} onMouseOver={openSubMenuHover(subLinkMenuHover)}>
        <LinkComponent {...linkData} >
          {
            props.navIcon != undefined && props.navIcon != null ?
              <div className={styles.navIconContainer}>
                {props.navIcon}
              </div>
              :
              <></>
          }
          {
            props.navText != undefined && props.navText != null ?
              <div className={props.expanded == true ? styles.navText + " " + styles.navTextSubMenu + " " + styles.expanded : styles.navText + " " + styles.navTextSubMenu}>
                <span>{props.navText}</span>
                <KeyboardArrowUpIcon className={subMenuOpen == true ? styles.subMenuArrowOpen : styles.subMenuArrow} />
              </div>
              :
              <></>
          }
          {
            props.children != undefined ?
              <div ref={subLinkMenuHover} className={styles.subMenuHover} style={subMenuAnchor != undefined && subMenuAnchor != null ? subMenuAnchor : {}}>
                <span className={styles.subTitle}>{props.navText}</span>
                <div className={styles.subLink}>
                  {props.children}
                </div>
              </div>
              :
              <></>
          }
        </LinkComponent>
        {
          props.children != undefined ?
            <div className={styles.subMenu} style={subMenuOpen == true && props.expanded == true ? { height: "auto" } : { height: "0px" }}>
              <div className={styles.subMenuContent}>
                {props.children}
              </div>
            </div>
            :
            <></>
        }
      </div>
    );
  }
  else {
    return (
      <LinkComponent {...linkData}>
        {
          props.navIcon != undefined && props.navIcon != null ?
            <div className={styles.navIconContainer}>
              {props.navIcon}
            </div>
            :
            <></>
        }
        {
          props.navText != undefined && props.navText != null ?
            <span className={props.expanded == true ? styles.navText + " " + styles.expanded : styles.navText}>{props.navText}</span>
            :
            <></>
        }
      </LinkComponent>
    );
  }
}

export default NavItem;